export default {"src":"/_next/static/media/loader.ec4e06c4.gif","height":864,"width":864,"blurWidth":0,"blurHeight":0};